// src/pages/AccessibleGalapagos.js
import React from 'react';
import AccessibilityTools from '../AccessibilityTools';
import GalapagosHistory from '../GalapagosHistory';

const AccessibleGalapagos = () => {
  return (
    <div>
      <AccessibilityTools />
      <GalapagosHistory />
    </div>
  );
};

export default AccessibleGalapagos;
